import {
    VirtualMirror,
    InitializationParams,
    VMInitializationOptions,
    RenderMirrorParams,
    VirtualMirrorCatalogue,
    UpcAvailability
} from '@luxottica/virtual-mirror';

/*const initOptions = {
    brand: 'shadestation',
    key: '8f7faf71-e21f-4da0-ac4f-6b61b454bf6c',
    locale: 'en-US',
    storeId: '',
    channel: 'license'
}*/

const initOptions = {
    key: '8f7faf71-e21f-4da0-ac4f-6b61b454bf6c', // shared by VM team, if you have only the SSH key, open a ticket
    brand: 'shadestation', // to be defined with Luxottica's Analytics team
    storeId: '', // to be defined with Luxottica's Analytics team
    channel: 'license', // to be defined with Luxottica's Analytics team
    locale: 'en-US',
}
const initParams = {
    options: initOptions
}

window.addEventListener("load", function() {

    var message = {};
    message.msgtype = "iframeloaded";

    window.parent.postMessage(JSON.stringify(message), '*');

});

function sendavailmsg(availibility) {
    var message = {};
    message.msgtype = "availreturned";
    message.isavailable = availibility;

    window.parent.postMessage(JSON.stringify(message), '*');
}

window.addEventListener('message', function (e) {
    const data = e.data;
    let decoded;

    if(e.origin == window.location.origin) {
            try {
                if (typeof data === 'string') {
                    if (data.trim() == "") {
                        return;
                    }
                    decoded = JSON.parse(data);
                } else if (data && typeof data === 'object') {
                    decoded = data;
                } else {
                    return;
                }
            } catch (error) {
                return;
            }

                switch (decoded.msgtype) {
                    case "availibility":

                        const VMCatalogue = VirtualMirrorCatalogue.build({
                            key: '8f7faf71-e21f-4da0-ac4f-6b61b454bf6c'
                        });

                        var upc = decoded.upc;

                        const result = VMCatalogue.isUpcSupported(upc);

                        result[upc].then((response) => {
                            if (response.isAvailable()) {
                                sendavailmsg(true);
                            } else {
                                sendavailmsg(false);
                            }
                        });

                        break;
                    case "resize":
                        document.getElementById("vmframe").style.height = decoded.height + "px";
                        document.getElementById("vmframe").style.width = decoded.width + "px";
                    break;
                    case "render":
                        var upc = decoded.upc;
                        document.getElementById("vmframe").style.height = decoded.height + "px";
                        document.getElementById("vmframe").style.width = decoded.width + "px";
                        VirtualMirror.initialize(initParams).then(function () {
                            const renderParams = {
                                target: 'vmframe',
                                upc: upc,
                                options: {}
                            };

                            return VirtualMirror.renderMirror(renderParams);
                        });
                        break;
                    case "fitbetter":
                        VirtualMirror.fitMeBetter();
                        break;

                    case "screenshot":
                        VirtualMirror.getScreenshot('image/png', 0.95).then(function (screenshot) {
                            window.parent.postMessage(JSON.stringify({
                                msgtype: 'screenshotreturned',
                                imgURI: screenshot.imgURI,
                                width: screenshot.width,
                                height: screenshot.height
                            }), '*');
                        }).catch(function (error) {
                            window.parent.postMessage(JSON.stringify({
                                msgtype: 'screenshotfailed',
                                error: error && error.message ? error.message : 'Screenshot unavailable'
                            }), '*');
                        });
                        break;

                    }
                }
});





/*var MirrorManager = new Class({

    initialize: function() {
        this.checkProductViability();
    },

    checkProductViability: function() {

        if($chk($("button_trymeon")) && $("button_trymeon").get("ean") != "") {

            const VMCatalogue = VirtualMirrorCatalogue.build({
                key: '8f7faf71-e21f-4da0-ac4f-6b61b454bf6c'
            });

            const upc = $("button_trymeon").get("ean");

            this.currentupc = upc;

            const result = VMCatalogue.isUpcSupported(upc);

            result[upc].then((response) => {
                if(response.isAvailable()) {
                    this.buildMirrorAndPopup();
                }
            })

        }
    },

    flexClicked: function(e) {

        console.log(e);

        if(e.target == this.flexcenter) {
            this.closePopup();
        }

    },

    closePopup: function() {
        this.fadeback.setStyle("display", "none");
        this.flexcenter.setStyle("display", "none");

    },

    privacyDeclined: function() {
        this.privacyfadeback.setStyle("display", "none");
        this.flexcentervm.setStyle("display", "none");
    },

    privacyAccepted: function() {
        this.privacyfadeback.setStyle("display", "none");
        this.flexcentervm.setStyle("display", "none");

        this.fadeback.setStyle("display", "block");
        this.flexcenter.setStyle("display", "flex");

        //setup and initialise the VM
        _gaq.push(["_trackEvent", "Virtual Mirror", "Opened"]);

        VirtualMirror.initialize(initParams).then(function() {
            const renderParams = {
                target: 'vmmaincontainer',
                upc: $("button_trymeon").get("ean")
            };

            return VirtualMirror.renderMirror(renderParams);
        });
    },

    trymeonButtonClicked: function() {
        this.privacyfadeback.setStyle("display", "block");
        this.flexcentervm.setStyle("display", "flex");
    },

    fitBetterClicked: function() {
        VirtualMirror.fitMeBetter();
    },

    buildMirrorAndPopup: function() {
        //create the popup mirror and background...

        this.privacyfadeback = new Element("div", {"class": "vmfadeback"}).inject(document.body);
        this.flexcentervm = new Element("div", {"class": "vmflexcenter"}).inject(document.body);

        this.privacypopup = new Element("div", {"class": "vmprivacy"}).inject(this.flexcentervm);

        this.privacytext = new Element("div", {"class": "vmtext", "html": "<div class='vmprivacytitle'>Virtual Mirror Privacy Policy</div><p>This policy illustrates how Luxottica Group S.p.A. (hereinafter, 'Luxottica' or 'We' or 'Us'), with registered office at Piazzale Cadorna, 3, 20123, Milano – Italy, directly or through its subsidiaries, processes personal data of the users of the 'Virtual Mirror' feature according to art. 13 of the EU General Data Protection Regulation 2016/679 ('GDPR').<br/><br/>" +
                "Luxottica has appointed a Data Protection Officer for the Group that can be contacted at <a href='mailto:dpo@luxottica.com'>dpo@luxottica.com</a>.<br/><br/>" +
                "Luxottica will process your personal data ('Image') if you want to use the Virtual Mirror feature on your device.  Luxottica processes this Image so that it can enable the Virtual Mirror feature and show you the right fit of the lenses.<br/><br/>" +
                "Your Image will not be communicated to anyone and will not be stored by Luxottica. The Image is processed live and not stored by Luxottica.<br/><br/>" +
                "If you click the 'Take a Screenshot' button the Image will be stored on your device and Luxottica will not be able to access it.<br/><br/>" +
                "To the extent possible, you have the rights referred to in articles 15-21 GDPR (right to access, right of confirmation, right to be forgotten, right of processing limitation, right of data portability, right to object) and the right to complain to the Supervisor Authority.</p>"}).inject(this.privacypopup);

        this.privacybuttons = new Element("div", {"class": "vmbuttons"}).inject(this.privacypopup);

        this.privacyaccept = new Element("div", {"class": "vmbutton", "html": "Accept"}).inject(this.privacybuttons);

        this.privacydecline = new Element("div", {"class": "vmbutton", "html": "Decline"}).inject(this.privacybuttons);

        this.privacyaccept.addEvent("click", this.privacyAccepted.bind(this));
        this.privacydecline.addEvent("click", this.privacyDeclined.bind(this));

        this.fadeback = new Element("div", {"class": "vmfadeback"}).inject(document.body);
        this.flexcenter = new Element("div", {"class": "vmflexcenter"}).inject(document.body);
        this.mirrorpopup = new Element("div", {"class": "virtualmirrorpopup"}).inject(this.flexcenter);

        this.titleholder = new Element("div", {"class": "vmtitleandcross"}).inject(this.mirrorpopup);

            this.vmtitle = new Element("div", {"class": "vmtitle"}).inject(this.titleholder);

                new Element("img", {"class": "trymeonface", "src": "/skin/shadestation/images/newimages/try-on-button-camera.png"}).inject(this.vmtitle);

                new Element("div", {"class": "trymeontitle", "html": "Try me on"}).inject(this.vmtitle);

            this.vmcross = new Element("div", {"class": "vmcross", "html": "X"}).inject(this.titleholder);

        this.virtualmirrorcontainer = new Element("div", {"class": "vmmaincontainer", "id": "vmmaincontainer"}).inject(this.mirrorpopup);

        this.vmfooter = new Element("div", {"class": "vmfooter"}).inject(this.mirrorpopup);

        this.footerbutton = new Element("div", {"class": "fitmebetter", "html": "fit me better"}).inject(this.vmfooter);

        this.vmcross.addEvent("click", this.closePopup.bind(this));
        this.flexcenter.addEvent("click", this.flexClicked.bind(this));

        //show the button and attach the event to the button
        $("button_trymeon").addEvent("click", this.trymeonButtonClicked.bind(this));
        $("button_trymeon").setStyle("display", "flex");

        this.footerbutton.addEvent("click", this.fitBetterClicked.bind(this));

    }

});


window.addEvent("domready", function() {

    new MirrorManager();


});
*/

